// extracted by mini-css-extract-plugin
export default {"button":"button_button__rr3yo","buttonText":"button_buttonText__2xR1P","learn_bnt":"button_learn_bnt__guHaV"};